import { useOktaAuth } from '@okta/okta-react'
import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { Typography, Grid, Card, CardContent, CardActions, TextField, IconButton, Tabs, TabList, Tab, TabPanels, Button, SelectField, Option } from "@deere/fuel-react";
import { SELFSERVICE_ADMIN, SELF_SERVICE_TEMPLATE_STATUS, STATUS_COMPLETED, STATUS_DRAFT, SELF_SERVICE_NO_SURVEYS_CREATED, SELF_SERVICE_FILTER_IN_FILTER, FETCHING_YOUR_SURVEYS, SELF_SERVICE_STEP_TITLES, SELF_SERVICE_STEPS, LBL_CONFIRMATION, SELF_SERVICE_LANDING_DELETE_CONFIRMATION, NO, YES, LBL_SUCCESS, SURVEY_DELETE_SUCCESS, LBK_OK, LBL_ERROR, ALL, SURVEY_PUBLISH_SUCCESS, SELFSERVICE_PATH, CRS_SURVEY_TEMPLATES, PROMOTE_NEW_SURVEY_OPTION } from "../../../utils/surveyLiterals";
import { useUserInfo } from "../../../providers/userProvider";
import { ERR_DATA_FETCH, ERR_EXISTING_REVISION, ERR_SURVEY_PUBLISH, ERR_TITLE_ACCESS, ERR_SURVEY_PROMOTE } from "../../../utils/errorLiterals";
import { useHistory } from 'react-router'
import { ReactComponent as DeleteIcon } from '@deere/ux.brand-foundations/icons/delete.svg';
import { ReactComponent as EditIcon } from "@deere/ux.brand-foundations/icons/edit.svg";
import { ReactComponent as PublishIcon } from "@deere/ux.brand-foundations/icons/file_upload.svg";
import { ReactComponent as ViewIcon } from "@deere/ux.brand-foundations/icons/visibility_on.svg";
import { ReactComponent as RevisionIcon } from "@deere/ux.brand-foundations/icons/add_note.svg";
import OutboxIcon from '@mui/icons-material/Outbox';
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox';
import {deleteSurveySelfService, getSurveyLiterals, getSelfServiceTemplateBySurveyCode, promoteNewSurvey, promoteToExistingSurvey} from '../../../services/survey.service'
import { getSelfServiceSurveys } from '../../../services/campaign.service';
import { saveSurveySelfService, getSurveyTemplates } from "../../../services/survey.service";
import { getDateFromTimeStamp, prepareSurveyData, removeUnwantedProperties } from '../../../utils/utils';
import { GenericFuelModal } from '../../../components/modals/GenericFuelModal';
import { PromoteSurveyModal } from '../../../components/modals/PromoteSurveyModal';
import { validateSelfServiceSurvey } from '../../../utils/validation';
import { getSuppSurveyConfiguration } from '../../../services/userService';
import { Spinner } from '@deere/ux.uxframe-react';
import { CURRENT_ENV } from '../../../utils/constEnvVariables';
import { ENV_PROD } from '../../../utils/surveyLiterals';

const SelfServiceLandingPage = () => {
  const { authState } = useOktaAuth();
  const userInfo = useUserInfo();
  const history = useHistory();
  const [surveys, setSurveys] = useState([]);
  const [filteredSurvey, setFilteredSurvey] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [inputFilter, setInputFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [templateFilter, setTemplateFilter] = useState("");
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] = useState(false);
  const [showDeleteSuccessModal, setShowDeleteSuccessModal] = useState(false);
  const [showPublishSuccessModal, setShowPublishSuccessModal] = useState(false);
  const [showPublishErrorModal, setShowPublishErrorModal] = useState(false);
  const [surveyDelete, setSurveyDelete] = useState({});
  const [loading, setLoading] = useState(true);
  const [errorDuringSurveyFetch, setErrorDuringSurveyFetch] = useState(false);
  const [showRevisionErrorModal, setShowRevisionErrorModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showPromoteSurveyModal, setShowPromoteSurveyModal] = useState(false);
  const [surveyToPromote, setSurveyToPromote] = useState(null);
  const [showPromoteErrorModal, setShowPromoteErrorModal] = useState(false);
  const [showPromoteSuccessModal, setShowPromoteSuccessModal] = useState(false);
  const [promotedSurveyInfo, setPromotedSurveyInfo] = useState(null);

  useEffect(() => {
    loadSurveys();    
  }, []);

  useEffect(() => {
    getSurveyTemplates(authState.accessToken.accessToken)
      .then((surveys) => {
        setTemplates(surveys);
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    if (surveys.length > 0) {
      let surveysAfterFilter = [...surveys];
      if (inputFilter !== "")
        surveysAfterFilter = surveys.filter((s) => {
          return s.code.toLowerCase().includes(inputFilter) || s.description.toLowerCase().includes(inputFilter);
        });
      if (statusFilter !== "")
        surveysAfterFilter = surveysAfterFilter.filter((s) => {
          return s.templateStatus === statusFilter;
        });
      if (templateFilter !== "")
        surveysAfterFilter = surveysAfterFilter.filter((s) => {
          return s.templateType === templateFilter;
        });
      setFilteredSurvey(surveysAfterFilter);
    }
  }, [surveys, inputFilter, statusFilter, templateFilter]);

  const loadSurveys = () => {
    setLoading(true);
    setErrorDuringSurveyFetch(false);
    getSelfServiceSurveys(authState.accessToken.accessToken)
      .then((selfServicesurveys) => {
        setSurveys(selfServicesurveys);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        setErrorDuringSurveyFetch(true);
      });
  };

  const openCampaignScreen =()=>{
    history.push({
      pathname: SELFSERVICE_PATH,
      state: { previous: history.location.pathname }
  })
  }

  const fetchSurveyData = async (surveyId) => {
    try {
      if (surveyId) {
        const surveyData = await getSuppSurveyConfiguration(surveyId, ALL, authState.accessToken.accessToken);
        const literalData = await getSurveyLiterals(surveyId, null, authState.accessToken.accessToken);
        const notificationData = await getSelfServiceTemplateBySurveyCode(surveyData.code, authState.accessToken.accessToken);
        if (surveyData && literalData && notificationData) {
          return prepareSurveyData(surveyData, literalData, notificationData);
        }
      }
      return null;
    } catch (err) {
      console.log(err);
      return null;
    }
  };

  const isRevision = (code) => {
    const surveyVersions = surveys.filter((sur) => sur.code === code);
    if (surveyVersions && surveyVersions.length > 1) {
      return true;
    }
    return false;
  };

  const handleEdit = async (surveyId) => {
    setIsLoading(true);
    const surveyData = await fetchSurveyData(surveyId);
    if(surveyData) {
      surveyData.editSurvey = isRevision(surveyData.code);
      // Promoted drafts arrive with active=true; it must only become true when published from the last step
      surveyData.active = false;
      history.push({
        pathname: SELFSERVICE_PATH,
        state: { previous: history.location.pathname, surveyId: surveyId, step: 0, payloadData: surveyData },
      });
    }
    setIsLoading(false);
  };
  
  const handleDelete = () => {
      setIsLoading(true);
      deleteSurveySelfService(surveyDelete.id, authState.accessToken.accessToken)
      .then((res) => {
        setIsLoading(false);
        setShowDeleteConfirmationModal(false);
        setShowDeleteSuccessModal(true);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        setShowDeleteConfirmationModal(false);
      });
  }
  const deleteClick = (survey) => {
    setShowDeleteConfirmationModal(true);
    setSurveyDelete(survey);
  }


  const handleView = async (surveyId) => {
    const surveyData = await fetchSurveyData(surveyId);
    if (surveyData) {
      const stepToOpen = SELF_SERVICE_STEPS.find((step) => step.title === SELF_SERVICE_STEP_TITLES.REVIEW_STEP);
      history.push({
        pathname: SELFSERVICE_PATH,
        state: { previous: history.location.pathname, surveyId: surveyId, step: stepToOpen.id, stepTitle: SELF_SERVICE_STEP_TITLES.REVIEW_STEP, payloadData: surveyData },
      });
    }
  };

  const refinePayloadData = (payloadData) => {
    //Removing empty values from the payload
    return {
      ...payloadData,
      translations: payloadData.translations.filter((translation) => translation.text && translation.text !== ""),
      sections: payloadData.sections
        .filter((section) => section.description && section.description !== "")
        .map((section) => ({
          ...section,
          translations: section.translations.filter((translation) => translation.text && translation.text !== ""),
          questions: section.questions
            .filter((question) => question.text && question.text !== "")
            .map((question) => ({
              ...question,
              translations: question.translations.filter((translation) => translation.text && translation.text !== ""),
              selections: question.selections
                .filter((selection) => selection.text !== "")
                .map(({ point, longDescription, ...rest }) => ({ ...rest, translations: rest.translations.filter((translation) => translation.text && translation.text !== "") })),
            })),
        })),
    };
  };
  
  const handlePublish = async (surveyId) => {
    setIsLoading(true);
    const surveyData = await fetchSurveyData(surveyId);
    if (surveyData) {
      surveyData.editSurvey = isRevision(surveyData.code);
      const payloadRefined = refinePayloadData(surveyData);
      const isPartTemplate = surveyData.templateType === CRS_SURVEY_TEMPLATES.PART;
      if (validateSelfServiceSurvey(payloadRefined, isPartTemplate)) {
        payloadRefined.templateStatus = STATUS_COMPLETED;
        payloadRefined.active = true;
        saveSurveySelfService(payloadRefined, authState.accessToken.accessToken)
          .then((survey) => {
            setShowPublishSuccessModal(true);
          })
          .catch((err) => console.log(err));
      } else {
        setShowPublishErrorModal(true);
      }
    }
    setIsLoading(false);
  };

  const handleRevision = async (surveyId) => {
    if (surveyId) {
      const surveyData = await fetchSurveyData(surveyId);
      //Checking if there is a existing revision in process
      const surveysByCode = surveys && surveyData ? surveys.filter((s) => s.code === surveyData.code) : [];
      const existingDraftSurvey = surveysByCode.find((s) => s.templateStatus === STATUS_DRAFT && Number(s.templateRevision) > Number(surveyData.templateRevision));
      if (existingDraftSurvey) {
        setShowRevisionErrorModal(true);
      } else {
        removeUnwantedProperties(surveyData);
        surveyData.editSurvey = true;
        surveyData.active = false;
        surveyData.templateStatus = STATUS_DRAFT;
        surveyData.templateRevision = (Number(surveyData.templateRevision) + 1).toString();
        history.push({
          pathname: SELFSERVICE_PATH,
          state: { previous: history.location.pathname, surveyId: surveyId, step: 0, payloadData: surveyData, isRevision: true },
        });
      }
    }
  }

  const handleMoveToEnvironment = async (surveyId) => {
    if (!userInfo || !userInfo.roles.includes(SELFSERVICE_ADMIN)) {
      return;
    }
    setSurveyToPromote(surveyId);
    setShowPromoteSurveyModal(true);
  };

  const handlePromoteSurvey = async (promoteOption, existingSurveyId) => {
    setShowPromoteSurveyModal(false);
    const survey = surveys.find((s) => s.id === surveyToPromote);
    if (promoteOption === PROMOTE_NEW_SURVEY_OPTION) {      
      if (survey) {
        try {
          const promotedSurveyResponse = await promoteNewSurvey(survey.code, authState.accessToken.accessToken);
          setPromotedSurveyInfo(promotedSurveyResponse.message);
          setShowPromoteSuccessModal(true);
          loadSurveys();
        } catch (err) {
          console.log(err);
          setPromotedSurveyInfo(ERR_SURVEY_PROMOTE);
          setShowPromoteErrorModal(true);
        }
      }
      return;
    }else{
      try {
        const promotedSurveyResponse = await promoteToExistingSurvey(survey.code, existingSurveyId, authState.accessToken.accessToken);
        setPromotedSurveyInfo(promotedSurveyResponse.message);
        setShowPromoteSuccessModal(true);
        loadSurveys();
      } catch (err) {
        console.log(err);
        setPromotedSurveyInfo(ERR_SURVEY_PROMOTE);
        setShowPromoteErrorModal(true);
      }   
    }
  };

  return (
    <>
      {isLoading && (
        <div className="d-flex w-100 justify-content-center align-items-center">
          <Spinner
            className="uxf-spinner-border-lg"
            animation="border"
          />
        </div>
      )}

      {/* rest of the JSX follows */}
      <Tabs>
        <TabList sx={{marginTop: "15px"}}>
          <Tab label="My Surveys"/>
          <Tab label="Shared with me" disabled/>
        </TabList>
        <TabPanels>
          <Grid container spacing={4} mt={3}>
            <Grid item xs={6} alignContent="center" mb={3}>
              <Button variant="primary" onClick={openCampaignScreen}>
                Create Survey
              </Button>
            </Grid>
            <Grid item xs={3} mb={3}>
              <TextField placeholder="Enter Survey Code or Title..." label="Search for survey" onChange={(e) => setInputFilter(e.target.value.trim().toLowerCase())} />
            </Grid>
            <Grid item xs={1.5} mb={3}>
              <SelectField label="Survey Type" value={templateFilter} onChange={(e) => setTemplateFilter(e.target.value)} notched="true">
                <Option value="">All</Option>
                {templates?.map((template) => (
                  <Option key={template.templateType} value={template.templateType}>
                    {template.templateType}
                  </Option>
                ))}
              </SelectField>
            </Grid>
            <Grid item xs={1.5} mb={3}>
              <SelectField label="Survey Status" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} notched="true">
                <Option value="">All</Option>
                {SELF_SERVICE_TEMPLATE_STATUS.map((status) => (
                  <Option key={status} value={status}>
                    {status}
                  </Option>
                ))}
              </SelectField>
            </Grid>
            {surveys.length === 0 ? (
              <Grid item xs={12}>
                <Card sx={{ justifyItems: "center" }}>
                  <CardContent>
                    <Typography variant="h2" paddingTop={20} paddingBottom={20}>
                      {loading ? FETCHING_YOUR_SURVEYS : errorDuringSurveyFetch ? ERR_DATA_FETCH : SELF_SERVICE_NO_SURVEYS_CREATED}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ) : filteredSurvey.length === 0 ? (
              <Grid item xs={12}>
                <Card sx={{ justifyItems: "center" }}>
                  <CardContent>
                    <Typography variant="h2" paddingTop={20} paddingBottom={20}>
                      {SELF_SERVICE_FILTER_IN_FILTER}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ) : (
              filteredSurvey.map((survey) => (
                <Grid item xs={12} md={6} lg={4} key={`${survey.code}_${survey.templateRevision}`}>
                  <Card>
                    <CardContent>
                      <Grid container direction="column" justifyContent="space-between" minHeight="220px">
                        <Grid item>
                          <Typography variant="h1" fontWeight="regular" size="2xl">
                            {survey.code}
                          </Typography>
                          <Typography variant="span" size="lg">
                            {survey.description}
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography variant="span" display="block" size="sm">
                            Type: {survey.templateType}
                          </Typography>
                          <Typography variant="span" display="block" size="sm">
                            Code: {survey.code}
                          </Typography>
                          <Typography variant="span" display="block" size="sm">
                            Version/Revision: {survey.templateRevision}
                          </Typography>
                          <Typography variant="span" display="block" size="sm">
                            Status: {survey.templateStatus}
                          </Typography>
                          <Typography variant="span" display="block" size="sm">
                            Last updated on: {getDateFromTimeStamp(survey.updatedTs)}
                          </Typography>
                          <Typography variant="span" display="block" size="sm">
                            Last updated by: {survey.updatedBy && survey.updatedBy !== "" ? survey.updatedBy : survey.createdBy}
                          </Typography>
                        </Grid>
                      </Grid>
                    </CardContent>
                    <CardActions justifyContent="flex-end" bgcolor="gray" sx={{padding: "7px"}}>
                    {survey.templateStatus === STATUS_DRAFT ? (
                        <>
                          <IconButton onClick={() => deleteClick(survey)} title={"Delete"}>
                            <DeleteIcon />
                          </IconButton>
                          <IconButton onClick={() => handleEdit(survey.id)} title={"Edit"}>
                            <EditIcon />
                          </IconButton>
                          <IconButton onClick={() => handlePublish(survey.id)} title={"Publish"}>
                            <PublishIcon />
                          </IconButton>
                        </>
                      ) : (
                        <>
                          <IconButton onClick={() => handleView(survey.id)} title={"View"}>
                            <ViewIcon />
                          </IconButton>
                          {survey.active && (
                            <IconButton onClick={() => handleRevision(survey.id)} title={"Create Revision"}>
                              <RevisionIcon />
                            </IconButton>
                          )}
                          {survey.active && (
                            <IconButton onClick={() => handleMoveToEnvironment(survey.id)} title={CURRENT_ENV === ENV_PROD ? "Promote to Lower Environment" : "Promote to Upper Environment"}>
                              {CURRENT_ENV === ENV_PROD ? <MoveToInboxIcon /> : <OutboxIcon />}
                            </IconButton>
                          )}
                        </>
                      )}
                    </CardActions>
                  </Card>
                </Grid>
              ))
            )}
          </Grid>
        </TabPanels>
      </Tabs>
      <GenericFuelModal
        title={LBL_CONFIRMATION}
        message={SELF_SERVICE_LANDING_DELETE_CONFIRMATION}
        show={showDeleteConfirmationModal}
        secondaryBtn={NO}
        handleClose={() => setShowDeleteConfirmationModal(false)}
        primaryButton={YES}
        handleSave={handleDelete}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      />
      <GenericFuelModal
        title={LBL_SUCCESS}
        message={SURVEY_DELETE_SUCCESS}
        show={showDeleteSuccessModal}
        handleClose={() => {
          setShowDeleteSuccessModal(false);
          loadSurveys();
        }}
        primaryButton={LBK_OK}
        handleSave={() => {
          setShowDeleteSuccessModal(false);
          loadSurveys();
        }}
      />
      <GenericFuelModal
        title={LBL_SUCCESS}
        message={SURVEY_PUBLISH_SUCCESS}
        show={showPublishSuccessModal}
        handleClose={() => {
          setShowPublishSuccessModal(false);
          loadSurveys();
        }}
        primaryButton={LBK_OK}
        handleSave={() => {
          setShowPublishSuccessModal(false);
          loadSurveys();
        }}
      />
      <GenericFuelModal
        title={LBL_ERROR}
        message={ERR_SURVEY_PUBLISH}
        show={showPublishErrorModal}
        handleClose={() => setShowPublishErrorModal(false)}
        primaryButton={LBK_OK}
        handleSave={() => setShowPublishErrorModal(false)}
      />
      <GenericFuelModal
        title={LBL_ERROR}
        message={ERR_EXISTING_REVISION}
        show={showRevisionErrorModal}
        handleClose={() => setShowRevisionErrorModal(false)}
        primaryButton={LBK_OK}
        handleSave={() => setShowRevisionErrorModal(false)}
      />
      <PromoteSurveyModal
        show={showPromoteSurveyModal}
        handleClose={() => setShowPromoteSurveyModal(false)}
        handleContinue={handlePromoteSurvey}        
        authState={authState}
      />
      <GenericFuelModal
        title={LBL_ERROR}
        message={promotedSurveyInfo}
        show={showPromoteErrorModal}
        handleClose={() => setShowPromoteErrorModal(false)}
        primaryButton={LBK_OK}
        handleSave={() => setShowPromoteErrorModal(false)}
      />
      <GenericFuelModal
        title={LBL_SUCCESS}
        message={promotedSurveyInfo}
        show={showPromoteSuccessModal}
        handleClose={() => {
          setShowPromoteSuccessModal(false);
          setPromotedSurveyInfo(null);
        }}
        primaryButton={LBK_OK}
        handleSave={() => {
          setShowPromoteSuccessModal(false);
          setPromotedSurveyInfo(null);
        }}
      />
    </>
  );
};

export default SelfServiceLandingPage;